/* =====================================================================
   HipClicks Nivela · PDP
   Ofertas (1 unidad / 1 + 1 de regalo), regalo con talla y color propios,
   autoplay de la galería, guía de tallas, fecha estimada, carrusel de
   comentarios, muro de reseñas y CTA final.
   Todo funciona sobre el formulario nativo del tema (product-form-component).
   ===================================================================== */

const $ = (s, c = document) => c.querySelector(s);
const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
const esc = (s) => String(s).replace(/[&<>"']/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[ch]);
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const scopeOf = (el) => el.closest('.shopify-section') || document.body;
const fire = (el, name, detail) => el.dispatchEvent(new CustomEvent(name, { bubbles: true, detail }));
const LOCALE = 'es-ES';

let CartAddEventClass = null;
import('@theme/events')
  .then((m) => { CartAddEventClass = m.CartAddEvent; })
  .catch(() => {});

const mainForm = (scope) => $('product-form-component form', scope);
const mainVariantId = (scope) => Number(scope._nvVariantId || mainForm(scope)?.querySelector('input[name="id"]')?.value || 0);
const variantPending = (scope) => Boolean(scope._nvPendingAt && Date.now() - scope._nvPendingAt < 4000);

/* ---------------------------------------------------------------------
   Ofertas: cambian la cantidad que se envía con el formulario nativo
   --------------------------------------------------------------------- */
function initOffers(root) {
  $$('[data-nv-offers]', root).forEach((fs) => {
    if (fs.dataset.nvInit) return;
    fs.dataset.nvInit = '1';
    const scope = scopeOf(fs);
    const apply = () => {
      const radio = $('input[type="radio"]:checked', fs) || $('input[type="radio"]', fs);
      if (!radio) return;
      radio.checked = true;
      const units = Math.max(1, Number(radio.dataset.units) || 1);
      const gifts = Math.min(units - 1, Math.max(0, Number(radio.dataset.gifts) || 0));
      const qty = $('[data-nv-qty]', fs);
      if (qty) qty.value = String(units);
      scope.dataset.nvUnits = String(units);
      scope.dataset.nvGifts = String(gifts);
      scope._nvOffer = radio;
      fire(scope, 'nv:offer', { units, gifts, title: radio.dataset.title || '' });
    };
    fs.addEventListener('change', apply);
    apply();
  });
}

/* ---------------------------------------------------------------------
   Regalo: por defecto igual que la variante elegida; se puede cambiar
   --------------------------------------------------------------------- */
function initGift(root) {
  $$('[data-nv-gift]', root).forEach((box) => {
    if (box.dataset.nvInit) return;
    box.dataset.nvInit = '1';
    const scope = scopeOf(box);
    let variants = [];
    try {
      variants = JSON.parse($('script[data-nv-variants]', box).textContent).variants || [];
    } catch (e) {
      variants = [];
    }
    scope._nvVariants = variants;
    const err = $('[data-nv-gift-err]', box);
    const slotEls = $$('[data-nv-gift-slot]', box);
    const slots = (slotEls.length ? slotEls : [box]).map((el) => ({
      el,
      selects: $$('select[data-nv-opt]', el),
      sum: $('[data-nv-gift-sum]', el),
      same: $('[data-nv-gift-same]', el),
      toggle: $('[data-nv-gift-toggle]', el),
      row: $('[data-nv-gift-row]', el),
      na: el.dataset.na || (err && err.dataset.na) || '',
      custom: false,
      id: 0,
      title: '',
    }));

    const byOptions = (opts) => variants.find((v) => v.options.every((o, i) => String(o) === String(opts[i])));

    const sync = () => {
      const main = variants.find((v) => v.id === mainVariantId(scope)) || variants[0];
      if (!main) return;
      const gifts = Number(scope.dataset.nvGifts) || 0;
      let naText = '';
      slots.forEach((s, i) => {
        const active = i < gifts;
        if (s.el !== box) s.el.hidden = !active;
        if (!s.custom) s.selects.forEach((sel) => { sel.value = main.options[Number(sel.dataset.nvOpt)]; });
        const opts = s.selects.map((sel) => sel.value);
        const v = byOptions(opts);
        if (s.sum) s.sum.textContent = v ? v.title : opts.join(' / ');
        if (s.same) s.same.hidden = !(v && v.id === main.id);
        s.id = v && v.available ? v.id : 0;
        s.title = s.id ? v.title : '';
        if (active && !s.id && !naText) naText = s.na;
      });
      const ids = [];
      for (let i = 0; i < gifts; i += 1) {
        const s = slots[Math.min(i, slots.length - 1)];
        ids.push(s ? s.id : 0);
      }
      box.dataset.giftIds = ids.join(',');
      box.dataset.giftId = slots[0] && slots[0].id ? String(slots[0].id) : '';
      box.dataset.giftTitle = slots[0] ? slots[0].title : '';
      box.dataset.giftNa = naText;
      if (err) {
        if (naText) {
          err.dataset.state = 'na';
          err.textContent = naText;
        } else if (err.dataset.state !== 'add') {
          err.textContent = '';
        }
      }
      box.hidden = !(gifts > 0);
      fire(box, 'nv:gift', { giftId: box.dataset.giftId, giftIds: ids, same: ids.every((id) => id === main.id) });
    };

    slots.forEach((s) => {
      s.selects.forEach((sel) => sel.addEventListener('change', () => {
        s.custom = true;
        if (err) err.dataset.state = '';
        sync();
      }));
      if (s.toggle && s.row) {
        s.toggle.addEventListener('click', () => {
          const open = s.row.hidden;
          s.row.hidden = !open;
          s.toggle.setAttribute('aria-expanded', String(open));
          s.toggle.textContent = open ? s.toggle.dataset.close : s.toggle.dataset.open;
        });
      }
    });
    scope.addEventListener('nv:offer', sync);
    scope.addEventListener('nv:variant', sync);
    sync();
  });
}

/* ---------------------------------------------------------------------
   Variante: actualiza precios de las ofertas y avisa al resto
   --------------------------------------------------------------------- */
document.addEventListener('variant:selected', (e) => {
  const scope = e.target.closest?.('.shopify-section');
  if (scope && $('[data-nv-offers]', scope)) scope._nvPendingAt = Date.now();
});

document.addEventListener('variant:update', (e) => {
  const scope = e.target.closest?.('.shopify-section');
  if (!scope || !$('[data-nv-offers], [data-nv-gift], [data-nv-title]', scope)) return;
  const html = e.detail?.data?.html;
  if (html && typeof html.getElementById === 'function') {
    $$('[data-nv-swap][id]', scope).forEach((el) => {
      const fresh = html.getElementById(el.id);
      if (fresh) el.innerHTML = fresh.innerHTML;
    });
  }
  const variant = e.detail?.resource;
  if (variant?.id) scope._nvVariantId = variant.id;
  scope._nvPendingAt = 0;
  fire(scope, 'nv:variant', { variant });
  setTimeout(() => applyAutoplay(scope), 400);
  if (scope._nvResubmit) {
    scope._nvResubmit = false;
    setTimeout(() => mainForm(scope)?.requestSubmit(), 60);
  }
});

/* ---------------------------------------------------------------------
   Añadir al carrito con regalo distinto (2 líneas) o durante un cambio
   de variante. Si el regalo es igual, lo hace el formulario del tema.
   --------------------------------------------------------------------- */
async function addItems(form, scope, items, units) {
  const pfc = form.closest('product-form-component');
  const gift = $('[data-nv-gift]', scope);
  const err = gift ? $('[data-nv-gift-err]', gift) : null;
  const url = window.Theme?.routes?.cart_add_url || `${window.Shopify?.routes?.root || '/'}cart/add.js`;
  const sections = $$('cart-items-component').map((el) => el.dataset.sectionId).filter(Boolean);
  const body = { items };
  if (sections.length) body.sections = sections.join(',');
  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok || json.status) throw new Error(json.description || json.message || 'error');
    if (err) { err.dataset.state = ''; err.textContent = ''; }
    const data = { source: 'product-form-component', itemCount: units, productId: pfc?.dataset.productId, sections: json.sections };
    const evt = CartAddEventClass
      ? new CartAddEventClass(json, pfc?.id || '', data)
      : Object.assign(new Event('cart:update', { bubbles: true }), { detail: { resource: json, sourceId: pfc?.id || '', data } });
    (pfc || document).dispatchEvent(evt);
  } catch (error) {
    if (err) {
      err.dataset.state = 'add';
      err.textContent = error && error.message && error.message !== 'error' ? error.message : err.dataset.msg || '';
    }
  }
}

window.addEventListener('submit', (e) => {
  const form = e.target;
  if (!(form instanceof HTMLFormElement) || !form.closest('product-form-component')) return;
  const scope = scopeOf(form);
  if (!$('[data-nv-offers]', scope)) return;
  const units = Number(scope.dataset.nvUnits) || 1;
  const gifts = Number(scope.dataset.nvGifts) || 0;
  const pending = variantPending(scope);
  const giftBox = $('[data-nv-gift]', scope);
  const mainId = mainVariantId(scope);
  const giftIds = giftBox ? (giftBox.dataset.giftIds || '').split(',').filter((x) => x !== '').map(Number) : [];
  const needsSplit = Boolean(gifts > 0 && giftBox && (giftIds.length < gifts || giftIds.some((id) => id !== mainId)));

  if (units <= 1 && !needsSplit) return;
  if (!pending && !needsSplit) return; // el tema lo añade con la cantidad de la oferta

  e.preventDefault();
  e.stopImmediatePropagation();

  if (pending) {
    scope._nvResubmit = true;
    return;
  }
  if (giftIds.length < gifts || giftIds.some((id) => !id)) {
    const err = $('[data-nv-gift-err]', giftBox);
    if (err) err.textContent = giftBox.dataset.giftNa || err.dataset.na || '';
    return;
  }
  const counts = new Map([[mainId, units - gifts]]);
  giftIds.slice(0, gifts).forEach((id) => counts.set(id, (counts.get(id) || 0) + 1));
  const items = Array.from(counts, ([id, quantity]) => ({ id, quantity })).filter((it) => it.quantity > 0);
  addItems(form, scope, items, units);
}, true);

/* ---------------------------------------------------------------------
   Galería: las imágenes pasan solas
   --------------------------------------------------------------------- */
function applyAutoplay(root) {
  if (reduceMotion || !window.customElements) return;
  $$('[data-nv-autoplay]', root).forEach((title) => {
    const seconds = Number(title.dataset.nvAutoplay) || 0;
    if (seconds <= 0) return;
    const scope = scopeOf(title);
    customElements.whenDefined('slideshow-component').then(() => {
      const show = $$('.product-information__media slideshow-component, media-gallery slideshow-component', scope).find((el) => !el.closest('dialog'));
      if (!show) return;
      if (show.getAttribute('autoplay') !== String(seconds)) show.setAttribute('autoplay', String(seconds));
      if (!show.hasAttribute('infinite')) show.setAttribute('infinite', '');
      if (typeof show.play === 'function' && !show.matches(':hover')) {
        show.suspend?.();
        show.play();
      }
    });
  });
}

/* ---------------------------------------------------------------------
   Guía de tallas (dialog)
   --------------------------------------------------------------------- */
document.addEventListener('click', (e) => {
  const opener = e.target.closest?.('[data-nv-open]');
  if (opener) {
    const dlg = document.getElementById(opener.dataset.nvOpen);
    if (dlg && typeof dlg.showModal === 'function' && !dlg.open) {
      dlg.showModal();
      document.documentElement.style.overflow = 'hidden';
      dlg.addEventListener('close', () => { document.documentElement.style.overflow = ''; }, { once: true });
    }
    return;
  }
  const closer = e.target.closest?.('[data-nv-close]');
  if (closer) {
    closer.closest('dialog')?.close();
    return;
  }
  if (e.target instanceof HTMLDialogElement && e.target.classList.contains('nv-drawer')) e.target.close();
});

/* ---------------------------------------------------------------------
   Fecha estimada de entrega (días laborables)
   --------------------------------------------------------------------- */
function addBusinessDays(from, n) {
  const d = new Date(from);
  let k = 0;
  while (k < n) {
    d.setDate(d.getDate() + 1);
    const w = d.getDay();
    if (w !== 0 && w !== 6) k += 1;
  }
  return d;
}
function initEta(root) {
  $$('[data-nv-eta]', root).forEach((el) => {
    const n = Number(el.dataset.nvEta) || 0;
    const tpl = el.dataset.tpl || '';
    if (!n || !tpl) return;
    const date = addBusinessDays(new Date(), n).toLocaleDateString(LOCALE, { weekday: 'long', day: 'numeric', month: 'long' });
    el.innerHTML = esc(tpl).replace('[fecha]', `<b>${esc(date)}</b>`);
  });
}

/* ---------------------------------------------------------------------
   Comentarios de la caja de compra (carrusel con puntos)
   --------------------------------------------------------------------- */
function initComments(root) {
  $$('[data-nv-cmts]', root).forEach((wrap) => {
    if (wrap.dataset.nvInit) return;
    wrap.dataset.nvInit = '1';
    const track = $('[data-nv-cmts-track]', wrap);
    const dots = $('[data-nv-dots]', wrap);
    const items = $$('.nv-cmt', track);
    if (!items.length) { wrap.hidden = true; return; }
    if (items.length < 2) { dots.hidden = true; return; }
    dots.innerHTML = items.map((_, i) => `<button type="button" aria-label="Comentario ${i + 1}"></button>`).join('');
    const btns = $$('button', dots);
    const sync = () => {
      const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      btns.forEach((b, j) => b.setAttribute('aria-current', String(i === j)));
    };
    track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
    btns.forEach((b, i) => b.addEventListener('click', () => track.scrollTo({ left: items[i].offsetLeft - items[0].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' })));
    sync();
  });
}

/* ---------------------------------------------------------------------
   Muro de reseñas: resumen, barras, fotos, filtros y «ver más».
   Solo cuenta las reseñas que se muestran (en la tienda: las reales).
   --------------------------------------------------------------------- */
const fmt1 = (n) => n.toLocaleString(LOCALE, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
let lastStats = null;

function fillRatings(avg, count) {
  lastStats = { avg, count };
  $$('[data-nv-rating][data-nv-auto]').forEach((el) => {
    if (!count) { el.hidden = true; return; }
    $$('[data-nv-avg]', el).forEach((n) => { n.textContent = fmt1(avg); });
    $$('[data-nv-count]', el).forEach((n) => { n.textContent = String(count); });
    $$('.nv-stars', el).forEach((s) => { s.style.setProperty('--nv-fill', `${(avg / 5) * 100}%`); s.setAttribute('aria-label', `${fmt1(avg)} de 5`); });
    el.hidden = false;
  });
}

function initWall(root) {
  const walls = $$('[data-nv-wall]', root);
  if (!walls.length) {
    if (lastStats) fillRatings(lastStats.avg, lastStats.count);
    else if (root === document) fillRatings(0, 0);
  }
  walls.forEach((wall) => {
    if (wall.dataset.nvInit) return;
    wall.dataset.nvInit = '1';
    const reviews = $$('[data-nv-review]', wall);
    const total = reviews.length;
    const pageSize = Number(wall.dataset.page) || 6;
    const top = $('[data-nv-wall-top]', wall);
    const filtersEl = $('[data-nv-filters]', wall);
    const moreWrap = $('[data-nv-more-wrap]', wall);
    const moreBtn = $('[data-nv-more]', wall);

    if (!total) {
      if (top) top.hidden = true;
      if (filtersEl) filtersEl.hidden = true;
      if (moreWrap) moreWrap.hidden = true;
      fillRatings(0, 0);
      return;
    }

    const stars = (r) => Number(r.dataset.stars) || 5;
    const avg = reviews.reduce((a, r) => a + stars(r), 0) / total;
    fillRatings(avg, total);
    $$('[data-nv-avg]', top).forEach((n) => { n.textContent = fmt1(avg); });
    $$('[data-nv-count]', top).forEach((n) => { n.textContent = String(total); });
    $$('.nv-stars', top).forEach((s) => s.style.setProperty('--nv-fill', `${(avg / 5) * 100}%`));

    const bars = $('[data-nv-bars]', wall);
    if (bars) {
      bars.innerHTML = [5, 4, 3, 2, 1].map((s) => {
        const n = reviews.filter((r) => stars(r) === s).length;
        return `<div class="nv-bar"><span>${s} ★</span><i style="--w:${((n / total) * 100).toFixed(1)}%"></i><span>${n}</span></div>`;
      }).join('');
    }

    const withPhoto = reviews.filter((r) => r.dataset.photo === '1');
    const photos = $('[data-nv-photos]', wall);
    if (photos) {
      const max = window.matchMedia('(min-width: 750px)').matches ? 7 : 3;
      const shown = withPhoto.slice(0, max);
      photos.innerHTML = shown.map((r) => {
        const img = $('.nv-rv__img img', r);
        const inner = img ? `<img src="${esc(img.currentSrc || img.src)}" alt="" loading="lazy">` : '<svg class="nv-i" viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="7" width="18" height="13" rx="2"/><path d="M8 7l1.5-2.5h5L16 7"/><circle cx="12" cy="13.5" r="3.5"/></svg>';
        return `<button type="button" class="nv-photo" data-nv-photo-filter aria-label="Ver reseñas con foto">${inner}</button>`;
      }).join('') + (withPhoto.length > shown.length ? `<button type="button" class="nv-photo nv-photo--more" data-nv-photo-filter>+${withPhoto.length - shown.length}</button>` : '');
      const cap = $('[data-nv-photos-cap]', wall);
      if (!withPhoto.length) { photos.hidden = true; if (cap) cap.hidden = true; }
    }

    let filter = 'all';
    let expanded = false;
    const labels = { all: wall.dataset.lAll || 'Todas', photo: wall.dataset.lPhoto || 'Con foto' };
    const options = [['all', `${labels.all} (${total})`]];
    if (withPhoto.length) options.push(['photo', `${labels.photo} (${withPhoto.length})`]);
    [5, 4, 3, 2, 1].forEach((s) => {
      const n = reviews.filter((r) => stars(r) === s).length;
      if (n) options.push([String(s), `${s} ★ (${n})`]);
    });
    if (filtersEl) {
      filtersEl.innerHTML = options.map(([k, l]) => `<button type="button" data-f="${k}" aria-pressed="${k === 'all'}">${esc(l)}</button>`).join('');
      if (options.length < 3) filtersEl.hidden = true;
    }

    const render = () => {
      const list = reviews.filter((r) => (filter === 'all' ? true : filter === 'photo' ? r.dataset.photo === '1' : stars(r) === Number(filter)));
      reviews.forEach((r) => { r.hidden = true; });
      list.forEach((r, i) => { r.hidden = !expanded && i >= pageSize; });
      if (moreWrap && moreBtn) {
        moreWrap.hidden = list.length <= pageSize;
        moreBtn.textContent = expanded ? (moreBtn.dataset.less || 'Ver menos') : `${moreBtn.dataset.more || 'Ver más reseñas'} (${list.length - pageSize})`;
      }
    };
    const setFilter = (k) => {
      filter = k;
      expanded = false;
      $$('button[data-f]', filtersEl || wall).forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.f === k)));
      render();
    };
    filtersEl?.addEventListener('click', (e) => {
      const b = e.target.closest('button[data-f]');
      if (b) setFilter(b.dataset.f);
    });
    photos?.addEventListener('click', (e) => {
      if (!e.target.closest('[data-nv-photo-filter]')) return;
      setFilter('photo');
      (filtersEl || wall).scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    });
    moreBtn?.addEventListener('click', () => {
      expanded = !expanded;
      render();
    });
    render();
  });
}

/* ---------------------------------------------------------------------
   CTA final: refleja la oferta y la variante elegidas arriba
   --------------------------------------------------------------------- */
function mainScope() {
  const fs = $('[data-nv-offers]');
  return fs ? scopeOf(fs) : null;
}

function renderFinal() {
  const scope = mainScope();
  $$('[data-nv-final]').forEach((box) => {
    if (!scope || !scope._nvOffer) return;
    const label = scope._nvOffer.closest('label');
    const price = $('[data-nv-price]', label)?.textContent.trim();
    const compare = $('[data-nv-compare]', label)?.textContent.trim() || '';
    const gifts = Number(scope.dataset.nvGifts) || 0;
    const title = scope._nvOffer.dataset.title || '';
    const sub = $('.nv-offer__main small', label)?.textContent.trim() || '';
    const pEl = $('[data-nv-f-price]', box);
    const cEl = $('[data-nv-f-compare]', box);
    const sEl = $('[data-nv-f-save]', box);
    if (pEl && price) pEl.textContent = price;
    if (cEl) cEl.textContent = compare;
    if (sEl) sEl.textContent = gifts > 0 ? title : sub;
    const choice = $('[data-nv-f-choice]', box);
    if (choice) {
      const variants = scope._nvVariants || [];
      const v = variants.find((x) => x.id === mainVariantId(scope));
      const giftBox = $('[data-nv-gift]', scope);
      let text = title;
      if (v && variants.length > 1) text += ` · ${v.title}`;
      const extraIds = giftBox ? (giftBox.dataset.giftIds || '').split(',').filter((x) => x !== '').map(Number) : [];
      if (gifts > 1 && v && extraIds.some((id) => id && id !== v.id)) {
        const names = [v.title].concat(extraIds.map((id) => (variants.find((x) => x.id === id) || {}).title || ''));
        text = `${title} · ${names.filter(Boolean).join(', ')}`;
      } else if (gifts > 0 && giftBox && giftBox.dataset.giftId && Number(giftBox.dataset.giftId) !== (v && v.id) && giftBox.dataset.giftTitle) {
        text += ` + ${box.dataset.giftWord || 'regalo'} ${giftBox.dataset.giftTitle}`;
      }
      choice.textContent = text;
      choice.closest('[data-nv-f-choice-row]')?.removeAttribute('hidden');
    }
  });
}

function initFinal(root) {
  $$('[data-nv-final]', root).forEach((box) => {
    if (box.dataset.nvInit) return;
    box.dataset.nvInit = '1';
    const atc = $('[data-nv-f-atc]', box);
    const change = $('[data-nv-f-change]', box);
    const goToBuyBox = () => {
      const target = $('[data-nv-offers]') || $('product-form-component');
      target?.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    };
    change?.addEventListener('click', goToBuyBox);
    atc?.addEventListener('click', () => {
      const scope = mainScope() || document;
      const form = mainForm(scope);
      const submit = form && $('button[type="submit"], button[name="add"]', form);
      if (!submit || submit.disabled) { goToBuyBox(); return; }
      const label = atc.querySelector('[data-nv-f-label]');
      const done = () => {
        if (!label) return;
        const original = label.textContent;
        label.textContent = box.dataset.added || original;
        setTimeout(() => { label.textContent = original; }, 2000);
      };
      document.addEventListener('cart:update', (ev) => { if (!ev.detail?.data?.didError) done(); }, { once: true });
      submit.click();
    });
  });
  renderFinal();
}
['nv:offer', 'nv:variant', 'nv:gift'].forEach((n) => document.addEventListener(n, renderFinal));

/* ---------------------------------------------------------------------
   Arranque (y recarga en el editor de temas)
   --------------------------------------------------------------------- */
function init(root = document) {
  initOffers(root);
  initGift(root);
  applyAutoplay(root);
  initEta(root);
  initComments(root);
  initWall(root);
  initFinal(root);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => init());
} else {
  init();
}
document.addEventListener('shopify:section:load', (e) => init(e.target));
